import React, { useEffect } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes, useLocation } from "react-router-dom";
import App from "./App";
import ArtistCard from "./Artist Component/Card/Artist.js";
import MyBookingHistory from "./BookingHistory/MyBooking.js";
import Carnival from "./Carnival/Carnival.js";
import CarnivalPassPayment from "./Carnival/CarnivalPassPayment.js";
import CarnivalPassPaymentStatus from "./Carnival/CarnivalPassPaymentStatus.js";
import CarnivalPassRefund from "./Carnival/CarnivalPassRefund.js";
import CarnivalPassRefundStatus from "./Carnival/CarnivalPassRefundStatus.js";
import Summerypage from "./Carnival/Summerypage.js";
import BookNowBookATable from "./Carnival/bookatablenow.js";
import { default as ClubDetails, default as ClubFullDetails } from "./Club About Us/Club_full_Details";
import PackageAboutUs from "./Club About Us/Package--about";
import ClubAgreement from "./Club Agreement/Agreement";
import ArtistAgreement from "./Club Agreement/Artist-agreement";
import Cancellationpolicy from "./Club Agreement/Cancellationpolicy";
import Privacypolicy from "./Club Agreement/Privacypolicy";
import RefundPolicy from "./Club Agreement/Refundpolicy";
import Termscondition from "./Club Agreement/Termsandcondition";
import ClubDetail from "./Club Detail Component/index.js";
import Clubaboutuspagesearch from "./Club-aboutus/Club-aboutussearch";
import Clubpage from "./Club-page/Clubpage";
import Favclub from "./Favorate Component/Userfavclub";
import AboutusPage from "./Footer section page/Aboutuspage";
import Asanartist from "./Footer section page/Asanartist";
import Services from "./Footer section page/Services";
import BookanArtist from "./Footer section page/bookanartist";
import ContactUs from "./Footer section page/contactus";
import PartnerwithUs from "./Footer section page/partnerwithus";
import Footer from "./Footer/Footer";
import Happeningparty from "./Happening Party page/Happeningparty";
import HappeningViewButton from "./Happening-paty-view-button/Happening-view";
import CommingSoon from "./Happening-paty-view-button/comming-soon";
import MusicViewButton from "./Happening-paty-view-button/music-zoner-view";
import Fireworks from "./Homepage/Newyearpagelight";
import Navbar from "./Navbar/Navbar";
import HoliFailed from "./New--Thankew--page/Holi-Failed-page";
import NewThankewPage from "./New--Thankew--page/NewThanke--page";
import OurArtist from "./Ourartist/OurArtist";
import PackagePrice from "./PackagePrice/PackagePrice";
import Paymentpage from "./Paymentpage";
import Successpage from "./Successpage";
import ThankewPage from "./Thankewpage/Thankew-page";
import BlogDetails from "./blog-page/Blogdetails.js";
import Blog from "./blog-page/blog";
import RegistrationLoginForm from "./club-registration-page/registration";
import EventBookNow from "./event-view-all-page/Event-booknow.js";
import EventAboutUS from "./event-view-all-page/event-about-us";
import EventViewAll from "./event-view-all-page/eventview";
import BookATableViewAll from "./favorate-hangout-page/Book-a-table-view-all";
import FavorateHangoutThumbnail from "./favorate-hangout-page/Favorate--hangout--thumbnail";
import FavorateHangoutViewall from "./favorate-hangout-page/Favorate-Hangout";
import GroupBookingViewall from "./favorate-hangout-page/GroupBookingViewall";
import NewlyAddedClubViewAll from "./favorate-hangout-page/NewlyAddedViewAll.js";
import PopularPackageView from "./favorate-hangout-page/Popular--Package--view--all";
import PopularPackageViewall from "./favorate-hangout-page/PopularPackage--View--all";
import TableBookingViewall from "./favorate-hangout-page/TableBooking--view--all";
import MyBooking from "./hamburger--content/My--Booking";
import MyNotification from "./hamburger--content/My--Notification";
import MyProfile from "./hamburger--content/My--Profile";
import MyFavorite from "./hamburger--content/My--favorate";
import SearchResult from './searchResult';
import CarnivalPassDetails from "./Carnival/CarnivalPassDetails.js";
import ClubCarnival from "./Carnival/ClubCarnival.js";
import GroupBooking from "./Components/Table_booking/PackageLeadForm.js";
import HomeV2 from './v2/home/index.js';
import { useState } from "react";
import PackageLeadSubmitted from "./Components/Table_booking/package-lead-submitted.js";
import RegistrationLoginFormSubmitted from "./club-registration-page/resgistration-submitted.js";
import EvenetListingPage from "./event-view-all-page/EvenetListingPage.js";
import BidListPage from "./My--Bidding--design/BidListPage.js";
import PartyPackageListingPage from "./My--Bidding--design/PartyPackageListingPage.js";
import TableBookingForm from "./Components/Table_booking/TableBookingForm.js";
import FeedPage from "./Feed Page/FeedPage.js";
import FeedPageUno from "./Feed Page/FeedPageUno.js";

import PaymentDonePage from "./Payment-successful/PaymentDonePage.js";
import PaymentConfirmPage from "./Payment-successful/PaymentConfirmPage.js";
import AddMenuPage from "./MenuPage/AddMenuPage.js";
import Home from "./CRP/pages/Home.jsx";
import VenuesListingPage from "./My--Bidding--design/VenuesListingPage.js";
import VenueClubDetailsPage from "./Club-aboutus/VenueClubDetailsPage.js";
import { Restaurant } from "@mui/icons-material";
import PartyPackageDetailPage from "./Club-aboutus/PartyPackageDetailPage.js";
import MyBookingPage from "./BookingHistory/MyBookingPage.js";
import EventDetailPage from "./event-view-all-page/EventDetailPage.js";
import TableLeadSubmitted from "./Components/Table_booking/TableLeadSubmitted.js";
import EventBooking from "./event-view-all-page/EventBooking.js";
import MetaHead from "./MetaHead.js";
import PartnerWithUs from "./PackagePrice/PartnerWithUs.js";
import OrderSummery from "./My--Bidding--design/OrderSummery.js";
import OrderSummary from "./My--Bidding--design/OrderSummery.js";
import Checkout from "./My--Bidding--design/Checkout.js";
import ContactUsThankYou from "./Footer section page/ContactUsThankYou.js";
import LoginPage from "./Navbar/LoginPage.js";
import CheckoutEvent from "./event-view-all-page/CheckoutEvent.js";
import MyFavClub from "./Favorate Component/MyFavClub.js";
import EventThankYouPage from "./event-view-all-page/EventThankYouPage.js";
import ArtistsListingPage from "./Artist Component/Card/ArtistsListingPage.js";
import '@flaticon/flaticon-uicons/css/all/all.css';
import useAppRedirect from "./AppRedirectModal/useAppRedirect.js";
import AppRedirectBar from "./AppRedirectModal/AppRedirectBar.js";
import useUserLocation from "./LocationPopUp/useUserLocation.js";
import LocationPopUpModal from "./LocationPopUp/LocationPopUpModal.js";
import FeedPageSideBar from "./Feed Page/custom-comp/FeedPageSideBar.js";
import AdPromotionalBanner from "./AdPromotionalBanner.js";
import { API_BASE_URL } from "./utils.js";
import MyBookingDetail from "./BookingHistory/MyBookingDetail.js";
import AddGuestList from "./MenuPage/custom-comp/AddGuestList.js";
import { requestPermission, listenForMessages } from "./firebase/push.js";
import { preReleaseLabel } from "@mui/material";


function NavbarConditional() {

  const location = useLocation();



  const hideNavbarRoutes = [
    "/",
    "/feed",
    "/packagedetailspage",
    "/as-club",
    "/booknow--table--cart",
    "/my--booking",
    "/my-Favorite--ham",
    "/booknow--table--cart/[^/]+$",
    "/nextPage",
    "/summerypage",
    "/my--profile",
    "/tablebooking--pass/[^/]+$",
    "/new--year",
    "/Carnival2k23/P/[^/]+$",
    "Carnival2k23/T/[^/]+$",
    "/my--bid",
    // "/",
    "/FavorateHangoutViewall",
    "/TableBookingViewall",
    "/GroupBookingViewall",
    "/PopularPackageViewall",
    "/Package-view-all",
    "/BookATableViewAll",
    "/Carnivals",
    "/artist-view-all",
    // "/result?",
    '/v2',
  ];
  const shouldShowNavbar = () => {
    return !hideNavbarRoutes.some((route) =>
      new RegExp(`^${route}(\/|$)`).test(location.pathname)
    );
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return shouldShowNavbar() ? <Navbar /> : null;
}
function FooterConditional() {
  const location = useLocation();
  const hideFooterRoutes = [
    "/my--profile",
    "/my-Favorite--ham",
    "/my--booking",
    "/my--Notification",
    "/booknow--table--cart/[^/]+$",
    "/nextPage",
    "/summerypage",
    "/tablebooking--pass/[^/]+$",
    "/event-book/[^/]+/[^/]+$",
    "/success",
    "/artist-view-all",
  ];

  const shouldShowFooter = () => {
    return !hideFooterRoutes.some((route) =>
      new RegExp(`^${route}(\/|$)`).test(location.pathname)
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return shouldShowFooter() ? <Footer /> : null;
}

function Routerpage() {

  const url = `${API_BASE_URL}/master/assets/uploads/`;



  const userData = JSON.parse(localStorage.getItem("userData") || "null");

  const { showModal, openApp, continueInBrowser } = useAppRedirect();
  const {
    locationAllowed,
    coords,
    requestLocation,
    errorMessage,
    hasCheckedPermission
  } = useUserLocation();

  const [showSideBar, setShowSideBar] = useState(false);
  const [createLeadModel, setCreateLeadModel] = useState(false);


  const [notif, setNotif] = useState([]);

  useEffect(() => {
    // Ask for push permission
    requestPermission();

    // Listen for foreground messages
    listenForMessages((payload) => {
      const notification = payload.notification;
      setNotif((prevNotif) => [...prevNotif, notification]);
    });
  }, []);





  return (
    <Router>
      <MetaHead />

      {/* {!locationAllowed && hasCheckedPermission && (
        <LocationPopUpModal
          onAllow={requestLocation}
          errorMessage={errorMessage}
        />
      )} */}



      {showModal && (
        <AppRedirectBar
          onOpenApp={openApp}
          onContinue={continueInBrowser}
        />
      )}

      <div className="router-page" >

        <div className="home-page-design">
          {/* <NavbarConditional /> */}
          <AdPromotionalBanner />
        </div>
        <div className="app-shell">
          <div className="web-app-sidebar-section">
            <div className='live-reel-header-text-profile-section mobile-app-sidebar'>

              <div className='live-reel-header-text'>
                <div className='live-reel-header-image' onClick={() => setCreateLeadModel(true)}>
                  <img
                    src={
                      userData?.img
                        ? url + userData.img
                        : "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"
                    }
                    alt="user-profile"
                  />
                </div>

                <div className='live-reel-header-text-content-input' onClick={() => setCreateLeadModel(true)}>
                  <input
                    type="search"
                    readOnly
                    placeholder={`What's on your mind ${userData?.name ? userData?.name : ''}?`}
                  />
                  <i class="in-mobile-view-only fi-rr-picture feed-profile-icon"></i>
                </div>

                <div className='live-reel-header-text-icon-mobile'>
                  <i class="fi fi-sr-menu-burger feed-profile-icon-mobile-burger" onClick={() => setShowSideBar(true)}></i>
                </div>

                <div className={`feed-page-sidebar ${showSideBar ? 'active' : ''}`}>
                  <div className='feed-page-sidebar-content'>
                    <FeedPageSideBar notif={notif} setShowSideBar={setShowSideBar} />
                  </div>
                </div>
                {showSideBar && (
                  <div
                    className='feed-page-sidebar-overlay'
                    onClick={() => setShowSideBar(false)}
                  ></div>
                )}


              </div>


              <div className='live-reel-header-text-icon-section'>
                <div className='lrhtis-icons blue-image' onClick={() => setCreateLeadModel(true)}><i class=" fi-rr-picture feed-profile-icon"></i>image</div>
                <div className='lrhtis-icons green-image' onClick={() => setCreateLeadModel(true)}><i class=" fi-br-video-camera-alt feed-profile-icon"></i>video</div>
                <div className='lrhtis-icons voilet-image' onClick={() => setCreateLeadModel(true)}><i class=" fi-rr-edit feed-profile-icon"></i>write text</div>
              </div>
            </div>
            <div className="web-app-sidebar">
              <FeedPageSideBar />
            </div>
          </div>
          <main className="app-content">
            <Routes className="">
              {/* <Route
            path="/:city/:area/:clubname"
            element={<Clubaboutuspagesearch />}
          ></Route> */}

              <Route exact path="/venues-restaurant/:clubname/:city/:area" element={<VenueClubDetailsPage />}></Route>

              {/* azam */}
              <Route exact path="/:clubInfo" element={<VenueClubDetailsPage />}></Route>

              {/* azam */}
              <Route exact path="/party-package/:packagedetail/:title" element={<PartyPackageDetailPage />}></Route>


              <Route exact path="/" element={<FeedPage />}></Route>

              {/* azam */}
              <Route
                path="/login"
                element={
                  userData ? <Navigate to="/" replace /> : <LoginPage />
                }
              />

              <Route exact path="/artist-page" element={<OurArtist />}></Route>
              <Route exact path="/club-about-us" element={<Clubpage />}></Route>
              <Route path="/refund-policy" element={<RefundPolicy />}></Route>
              <Route path="/artist-agreement" element={<ArtistAgreement />}></Route>
              <Route path="/club-agreement" element={<ClubAgreement />}></Route>
              <Route path="/partner-as-an-artist" element={<Asanartist />}></Route>
              <Route path="/about-us" element={<AboutusPage />}></Route>
              <Route path="/book-as-a-artist" element={<BookanArtist />}></Route>
              <Route path="/as-club" element={<PartnerwithUs />}></Route>
              <Route path="/custom-package-services" element={<Services />}></Route>
              <Route path="/contact-us" element={<ContactUs />}></Route>
              <Route path="/contact-us/thank-you" element={<ContactUsThankYou />}></Route>
              <Route
                path="/booknow--table--cart/:id"
                element={<BookNowBookATable />}
              ></Route>
              <Route path="/nextPage" element={<Summerypage />}></Route>

              <Route path="/carnival/:type" element={<Carnival />}></Route>
              <Route path="/carnival/:type/:club_id?" element={<ClubCarnival />}></Route>
              <Route path="/payCarnivalPass/:order_id" element={<CarnivalPassPayment />}></Route>
              <Route path="/CarnivalPassPaymentStatus/:order_id" element={<CarnivalPassPaymentStatus />}></Route>
              <Route path="/refundCarnivalPass/:order_id" element={<CarnivalPassRefund />}></Route>
              <Route path="/CarnivalPassRefundStatus/:order_id" element={<CarnivalPassRefundStatus />}></Route>
              <Route exact path="/:city/:area/:club/carnival/:id" element={<CarnivalPassDetails />}></Route>
              <Route exact path="/:city/:area/:club/carnival" element={<CarnivalPassDetails />}></Route>
              {/* <Route path="/event-book/:club_id/:id" element={<EventBookNow />}></Route> */}

              {/* azam */}
              <Route path="/event-book/:club_id/:id" element={<EventBooking />}></Route>
              <Route path="/checkout-event" element={<CheckoutEvent />}></Route>
              <Route path="/event/thank-you" element={<EventThankYouPage />}></Route>



              <Route path="/bid-list/:id" element={<BidListPage />}></Route>
              <Route path="/table-booking/:id" element={<OrderSummary />}></Route>
              <Route path="/package-booking/:id" element={<OrderSummary />}></Route>
              <Route path="/checkout/:orderId" element={<Checkout />}></Route>

              <Route path="/feed" element={<FeedPage />}></Route>
              <Route path="/feed-uno" element={<FeedPageUno />}></Route>




              <Route path="/cracker" element={<Fireworks />}></Route>
              {/* azam */}
              <Route path="/corporate-recreation-program" element={<Home />}></Route>
              <Route
                path="/happening-party-page"
                element={<Happeningparty />}
              ></Route>
              <Route
                path="/happening-view-page"
                element={<HappeningViewButton />}
              ></Route>
              <Route path="/music-view-page" element={<MusicViewButton />}></Route>
              <Route path="/comming-soon" element={<CommingSoon />}></Route>
              <Route
                path="/business-registration"
                element={<RegistrationLoginForm />}
              ></Route>
              <Route
                path="/business-registration-submitted"
                element={<RegistrationLoginFormSubmitted />}
              ></Route>

              <Route path="/privacy-policy" element={<Privacypolicy />}></Route>
              <Route
                path="/term-conditions-policy"
                element={<Termscondition />}
              ></Route>
              <Route
                path="/cancellation-policy"
                element={<Cancellationpolicy />}
              ></Route>
              <Route path="/payment" element={<Paymentpage />}></Route>


              {/* azam */}
              <Route path="/payment-done/:id" element={<PaymentDonePage />}></Route>
              <Route path="/payment-confirm" element={<PaymentConfirmPage />}></Route>
              <Route path="/add-menu/:id" element={<AddMenuPage />}></Route>
              <Route path="/add-guest/:id" element={<AddGuestList />}></Route>



              <Route path="/success" element={<Successpage />}></Route>
              <Route path="/our-artist" element={<Successpage />}></Route>
              {/* <Route path="/my-booking-history" element={<MyBookingHistory />}></Route> */}

              {/* azam */}
              <Route path="/my-bookings" element={<MyBookingPage />}></Route>
              <Route path="/my-bookings-details/:id" element={<MyBookingDetail />}></Route>



              <Route exact path="/:city/:area/:club/:packageName" element={<PackageAboutUs />}></Route>

              {/* azam */}
              <Route exact path="/package/:city/:area/:club/:packageName" element={<PartyPackageDetailPage />}></Route>




              <Route exact path={"/package-lead-form"} element={<GroupBooking />}></Route>
              <Route exact path={"/my-plan"} element={<GroupBooking />}></Route>
              <Route exact path={"/table-book-form"} element={<TableBookingForm />}></Route>
              <Route exact path={"/package-lead-submitted"} element={<PackageLeadSubmitted />}></Route>
              <Route exact path={"/table-booking-submitted"} element={<TableLeadSubmitted />}></Route>
              <Route exact path={"/v2"} element={<HomeV2 />}></Route>

              <Route path="/thank-you" element={<ThankewPage />}></Route>
              <Route path="/success" element={<Successpage />}></Route>

              {/* <Route path="/favourite-club" element={<Favclub />}></Route> */}

              {/* azam */}
              <Route path="/favourite-club" element={<MyFavClub />}></Route>

              {/* <Route path="/partner-with-us" element={<PackagePrice />}></Route> */}
              {/* azam */}
              <Route path="/partner-with-us" element={<PartnerWithUs />}></Route>
              <Route path="/my--booking" element={<MyBooking />}></Route>
              <Route path="/my--profile" element={<MyProfile />}></Route>
              <Route path="/my--Notification" element={<MyNotification />}></Route>
              <Route path="/my-Favorite--ham" element={<MyFavorite />}></Route>


              {/* <Route path="/events" element={<EventViewAll />}></Route> */}
              {/* azam */}
              <Route path="/events" element={<EvenetListingPage />}></Route>
              <Route path="/today-events" element={<EvenetListingPage />}></Route>


              <Route path="/thank--you--page" element={<NewThankewPage />}></Route>


              {/* <Route path="/party-packages/:id" element={<PopularPackageView />}></Route> */}

              {/* <Route exact path={"/party-packages"} element={<GroupBookingViewall />}></Route> */}
              {/* azam */}

              <Route path="/party-packages" element={<PartyPackageListingPage />} />
              {/* azam */}
              <Route path="/party-packages/:id" element={<PartyPackageListingPage />}></Route>
              <Route path="/party-packages/:title/:city" element={<PartyPackageListingPage />}></Route>


              <Route path="/FavorateHangoutThumbnail" element={<FavorateHangoutThumbnail />}></Route>
              <Route path="/TableBookingViewall" element={<TableBookingViewall />}></Route>
              <Route path="/GroupBookingViewall" element={<GroupBookingViewall />}></Route>
              {/* <Route path="/party-packages" element={<PopularPackageViewall />}></Route> */}

              {/* <Route path="/venues" element={<BookATableViewAll />}></Route> */}

              {/* azam */}
              <Route path="/venues" element={<VenuesListingPage />}></Route>

              <Route path="/venues/:cityname" element={<VenuesListingPage />}></Route>
              {/* <Route path="/venues/:cityname" element={<FavorateHangoutViewall />}></Route> */}


              <Route path="/newly-added-club-delhi-ncr-view-all" element={<NewlyAddedClubViewAll />}></Route>

              <Route path="/Payment-Failed" element={<HoliFailed />}></Route>
              <Route path="/ClubDetail/:id" element={<ClubDetails />}></Route>
              <Route path="/result" element={<SearchResult />}></Route>
              <Route path="/:city/:area/club/:clubname" element={<ClubFullDetails />}></Route>
              <Route path="/:city/:area/:club/event/:title" element={<EventAboutUS />} />

              {/* azam */}
              <Route path="/:city/:area/:club/event/:title" element={<EventAboutUS />} />
              <Route path="/event/:clubdetail/:eventname" element={<EventDetailPage />} />

              <Route path="/:city/:area/:club/recommendevent/:title" element={<EventAboutUS />} />
              <Route path="/blogs" element={<Blog />}></Route>

              <Route path="/artists" element={<ArtistCard />}></Route>
              {/* azam */}
              <Route path="/artists-test" element={<ArtistsListingPage />}></Route>

              <Route path="/blogs/:title" element={<BlogDetails />}></Route>
              <Route path="/club-detail" element={<ClubDetail />}></Route>
            </Routes>

          </main>
        </div>
      </div>
      <div className="footer-section">
        {/* <FooterConditional /> */}
      </div>
    </Router>
  );
}
export default Routerpage;
